module.exports = __webpack_public_path__ + "img/task_table_arrow.07169366.svg";